import Collect from './components';
import api from './api';
import { MENU_POSITIONS, RESOURCE_TYPES } from './utils/constants';

Object.assign(Collect, {
    MENU_POSITIONS,
    RESOURCE_TYPES
});

export { api };
export default Collect;
